import { Tooltip } from 'antd';
import { getDvcIcon, getDvcInfo } from '../../../utils/getDeviceInfo';
import './styles.scss';

interface Device {
  networkIp: string;
  networkPort: string;
  userAgent: string;
}

interface UsersDevicesListProps {
  devices: Device[];
}

export default function UsersDevicesList({ devices }: UsersDevicesListProps) {
  if (!devices || devices.length === 0) {
    return null;
  }

  return (
    <div className="users-devices-list">
      {devices.map((device: Device, deviceIndex: number) => {
        const deviceInfo = getDvcInfo(device.userAgent || '');
        const isDefaultPhone = deviceInfo.name === 'Phone';
        const dvcIcon = getDvcIcon(device.userAgent || '');

        return (
          <Tooltip
            key={deviceIndex}
            overlayClassName="device-tooltip-overlay"
            placement="top"
            title={
              <div className="device-tooltip-content">
                <div className="device-tooltip-header">
                  <img
                    src={deviceInfo.fullIcon}
                    alt={deviceInfo.name}
                    className="device-tooltip-logo"
                    style={isDefaultPhone ? { width: 40, height: 40, borderRadius: 100 } : {}}
                  />
                  {dvcIcon && <img style={{ width: 40, height: 40 }} src={dvcIcon} alt="" />}
                </div>
                <div className="device-tooltip-body">
                  <div className="device-tooltip-row">
                    <span className="device-tooltip-label">Network IP:</span>
                    <span className="device-tooltip-value">{device.networkIp || 'N/A'}</span>
                  </div>
                  <div className="device-tooltip-row">
                    <span className="device-tooltip-label">Network Port:</span>
                    <span className="device-tooltip-value">{device.networkPort || 'N/A'}</span>
                  </div>
                  <div className="device-tooltip-row">
                    <span className="device-tooltip-label">Device:</span>
                    <span className="device-tooltip-value">{renderUserAgent(device.userAgent) || 'N/A'}</span>
                  </div>
                </div>
              </div>
            }
          >
            <img
              src={deviceInfo.icon}
              alt={deviceInfo.name}
              className="device-icon"
              style={{ width: 16, height: 16, borderRadius: 100 }}
            />
          </Tooltip>
        );
      })}
    </div>
  );
}

function renderUserAgent(userAgent: string) {
  switch (true) {
    case userAgent.toLowerCase().includes('ringotel'):
      return 'Dataphone';
    default:
      return userAgent;
  }
}